export function clearContextSession() {
  localStorage.removeItem("ngStorage-session");
}

export function getContextSession() {
  const rawValue = localStorage.getItem("ngStorage-session") ?? "";
  return rawValue.replace(/"/g, "").trim();
}
